/* eslint-disable import/prefer-default-export */

export const CFA_RESULT_UPDATE = 'CFA_RESULT_UPDATE';
export const CFA_QUERY_UPDATE = 'CFA_QUERY_UPDATE';